import React from 'react';

import { useTranslation } from 'react-i18next';

import { DepButton } from '@pkg/components/deprecated';

import { AuthenticatorType } from '../../types';

import './Step.scss';

interface AuthConfirmationProps {
    type: AuthenticatorType;
    onConfirm: (type: AuthenticatorType) => void;
}

export const AuthConfirmation = ({ onConfirm, type }: AuthConfirmationProps) => {
    const { t } = useTranslation(['twoFactorAuth']);

    return (
        <>
            <div className="two-factor-auth-step__img two-factor-auth-step__img--large">
                <img src="/assets/img/party-popper@3x.png" alt="popper" />
            </div>
            <h2
                className="two-factor-auth-step__title"
                dangerouslySetInnerHTML={{ __html: t('2fa_step_confirmation_title') }}
            />
            <p className="two-factor-auth-step__detail">{t('2fa_step_confirmation_detail')}</p>
            <div className="two-factor-auth-step__img two-factor-auth-step__img--small">
                <img src="/assets/img/party-popper@3x.png" alt="popper" />
            </div>
            <DepButton classes="two-factor-auth-step__action" onClick={() => onConfirm(type)}>
                {type === AuthenticatorType.AuthenticatorApp ? 'Next' : 'Done'}
            </DepButton>
        </>
    );
};
